import React from "react";
import IconClose from "../../../dynamicicons/icon-close";
import VelavuIconButton from "../../../elements/velavu-icon-button";
import * as styles from "./pinned-list-header.module.scss";
import { classArr } from "../../../helper/style-helper";
import whitelabel from "../../../whitelabel";

export default function PinnedListHeader(props: {
	className?: string;
	label?: string;
	onClose?: VoidFunction;
}) {
	return (
		<div className={classArr(props.className, styles.container)}>
			<span className={styles.title}>{props.label ?? ""}</span>
			<VelavuIconButton onClick={props.onClose}>
				<IconClose color={whitelabel.palette.secondary500} />
			</VelavuIconButton>
		</div>
	);
}
